export type ContactViewModeType = "grid" | "byCategory";
export const ContactViewModes: ContactViewModeType[] = ["grid", "byCategory"];
